import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { colors, transition } from 'theme';

const RadioContainer = styled.div`
  display: inline-flex;
  min-height: 35px;
`;
const StyledLabel = styled.label`
  font-size: 18px;
  color: ${colors.battleshipGrey};
  padding-left: 11px;
  cursor: pointer;
`;
const StyledRadio = styled.input`
  background-color: ${colors.white};
  height: 16px;
  width: 16px;
  min-width: 16px;
  border: solid 1px ${colors.battleshipGrey};
  border-radius: 50%;
  padding: 3px;
  cursor: pointer;
  margin: 4px 0 3px;
  transition: all ${transition};
  && {
    appearance: none;
  }
  &:checked {
    background-clip: content-box;
    background-color: ${colors.waterBlue};
  }
  &:focus {
    border-color: ${colors.waterBlue};
    box-shadow: 0 0 0 1px ${colors.waterBlue};
    outline: 0;
  }
  &[disabled] {
    background: ${colors.silver};
    opacity: 0.5;
    cursor: auto;
    + label {
      color: #aaa;
    }
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const RadioButton = ({
  id,
  name,
  value,
  label,
  checked,
  onChange,
  required,
  ...props
}: {
  alignTop?: boolean;
  'data-qa-id'?: string;
  disabled?: boolean;
  id?: string;
  hideRadioButtons?: boolean;
  name?: string;
  value: string | boolean | number;
  label: ReactNode;
  checked: boolean;
  onClick?: () => void;
  onChange?: (arg0: string | boolean | number) => void;
  required?: boolean;
}) => (
  <RadioContainer>
    <StyledRadio
      type="radio"
      name={name}
      id={id}
      checked={checked}
      required={required}
      value={typeof value === 'string' ? value : value.toString()}
      onChange={(e) => {
        e.stopPropagation();

        if (onChange) {
          onChange(value);
        }
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
    <StyledLabel htmlFor={id}>{label}</StyledLabel>
  </RadioContainer>
);

// eslint-disable-next-line import/no-default-export
export default RadioButton;
